const DIMENSION_LABELS = {
  dai: "Dài",
  rong: "Rộng",
  cao: "Cao",
};

export function formatProductDetailLabel(key) {
  const value = String(key || "").trim();
  const normalized = value
    .toLocaleLowerCase("vi-VN")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d");

  if (DIMENSION_LABELS[normalized]) return DIMENSION_LABELS[normalized];
  return value ? value.charAt(0).toLocaleUpperCase("vi-VN") + value.slice(1) : "";
}
